var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ApprovalCallerNotOwnerNorApproved",
        type: "error",
    },
    {
        inputs: [],
        name: "ApprovalQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "BalanceQueryForZeroAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_initializationContractAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_calldata",
                type: "bytes",
            },
        ],
        name: "InitializationFunctionReverted",
        type: "error",
    },
    {
        inputs: [],
        name: "MintERC2309QuantityExceedsLimit",
        type: "error",
    },
    {
        inputs: [],
        name: "MintToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "MintZeroQuantity",
        type: "error",
    },
    {
        inputs: [],
        name: "NewOwnerIsZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NoHandoverRequest",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnerQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnershipNotInitializedForExtraData",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferCallerNotOwnerNorApproved",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferFromIncorrectOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferToNonERC721ReceiverImplementer",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "URIQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "Unauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "fromTokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toTokenId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "ConsecutiveTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "pendingOwner",
                type: "address",
            },
        ],
        name: "OwnershipHandoverCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "pendingOwner",
                type: "address",
            },
        ],
        name: "OwnershipHandoverRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        name: "RolesUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner_",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "address",
                name: "royalty_",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "royaltyBps_",
                type: "uint16",
            },
        ],
        name: "_initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_functionSelector",
                type: "bytes4",
            },
        ],
        name: "facetAddress",
        outputs: [
            {
                internalType: "address",
                name: "facetAddress_",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "facetAddresses",
        outputs: [
            {
                internalType: "address[]",
                name: "facetAddresses_",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_facet",
                type: "address",
            },
        ],
        name: "facetFunctionSelectors",
        outputs: [
            {
                internalType: "bytes4[]",
                name: "_facetFunctionSelectors",
                type: "bytes4[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "facets",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "facetAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "functionSelectors",
                        type: "bytes4[]",
                    },
                ],
                internalType: "struct IDiamondLoupe.Facet[]",
                name: "facets_",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
            },
        ],
        name: "getApp",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "implementation",
                        type: "address",
                    },
                    {
                        internalType: "bytes4",
                        name: "interfaceId",
                        type: "bytes4",
                    },
                    {
                        internalType: "bytes4[]",
                        name: "selectors",
                        type: "bytes4[]",
                    },
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                ],
                internalType: "struct INiftyKitAppRegistry.App",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getMintSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        name: "grantRoles",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "installApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
            },
        ],
        name: "installApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "result",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
            },
        ],
        name: "removeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "removeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        name: "renounceRoles",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        name: "revokeRoles",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "rolesOf",
        outputs: [
            {
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "salePrice",
                type: "uint256",
            },
        ],
        name: "royaltyInfo",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newBaseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer_",
                type: "address",
            },
        ],
        name: "setMintSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newTreasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "trustedForwarder",
                type: "address",
            },
        ],
        name: "setTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var BaseFacet__factory = /** @class */ (function (_super) {
    __extends(BaseFacet__factory, _super);
    function BaseFacet__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    BaseFacet__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BaseFacet__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BaseFacet__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BaseFacet__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BaseFacet__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    BaseFacet__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    BaseFacet__factory.bytecode = _bytecode;
    BaseFacet__factory.abi = _abi;
    return BaseFacet__factory;
}(ContractFactory));
export { BaseFacet__factory };
